var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isThereActiveFilters)?_c('TotemTag',{staticClass:"desktop-clear-filters",attrs:{"name":_vm.$t('CourseListFilter.clear_all_filters'),"clear":"true"},on:{"handleClick":_vm.removeAllTags}}):_vm._e(),_c('TotemToast',{ref:"toast"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }